export default __webpack_public_path__ + "static/media/pddIcon.1aa45cb5.svg";